// extracted by mini-css-extract-plugin
export default {"wrap":"vH-z","fullWidth":"wH-z","hideOnDesktop":"xH-z","content":"yH-z","hasOpenedNav":"zH-z","crumbsList":"AH-z","dropdownsWrap":"BH-z"};